module.exports = [{
      plugin: require('C:/Users/Genome/Development/gatsby/ryan-mcguirk-strata/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('C:/Users/Genome/Development/gatsby/ryan-mcguirk-strata/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
